module.exports = __webpack_public_path__ + "static/media/MapLocation_card_bg_03.1a7032d4.jpg";